import type {LidarTechnologyRepository} from '@/domain/interfaces/LidarTechnologyRepository';

export class GetAllLidarTechnoligiesUseCase {
  constructor(private readonly repository: LidarTechnologyRepository) {}
  async execute() {
    return this.repository.getAll();
  }
}
